<div class="exception-body notfound">
    <img src="assets/layout/images/logo-white.svg" alt="SmartBox" class="logo">

    <div class="exception-content">
        <div class="exception-title" translate>NOT_FOUND.NOT_FOUND</div>
        <div class="exception-detail" translate>NOT_FOUND.REQUESTED_RESOURCE_NOT_AVAIL</div>
        <a [routerLink]="['/']" translate>NOT_FOUND.GO_HOME</a>
    </div>
</div>
